"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindAll;
function bindAll(actions, stores) {
  if (Array.isArray(actions)) {
    return actions.map(function (action) {
      return action.bindTo(stores);
    });
  } else {
    return Object.keys(actions).reduce(function (binds, action) {
      binds[action] = actions[action].bindTo(stores);
      return binds;
    }, {});
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-act/lib/bindAll.js
 ** module id = 1688
 ** module chunks = 1
 **/